<script setup>
/* eslint semi: 1 */
import { defineProps } from 'vue';
import { FwbTooltip } from 'flowbite-vue';

defineProps({
  playTimes: {
    type: Array,
    required: true
  },
});

</script>

<template>
  <div>
    <FwbTooltip placement="right" theme="light">
      <template #trigger>
        <div
          class="flex items-center gap-1 cursor-pointer" data-component-element-id="schedule-items-see-all-playtimes"
        >
          <BaseIconSvg name="flowbite:eye-solid" class="w-4! h-4! text-[#84868B]" />
          <span class="text-[#84868B] text-xs">{{ $t('texts.seeAll') }}</span>
        </div>
      </template>
      <template #content>
        <div class="bg-white rounded w-68">
          <div class="font-semibold text-xs text-gray-900 border-b border-gray-200 py-[6px]">{{ $t('texts.allPlayTimes') }}</div>
          <div class="grid grid-cols-2 gap-2 py-2 max-h-40 overflow-y-auto">
            <div
              v-for="(time, timeIndex) in playTimes"
              :key="`time-${timeIndex}`"
              class="rounded-lg px-2 py-0.5 flex shrink-0 justify-center items-center"
              :data-component-element-id="`schedule-grid-item-time-${timeIndex}`"
              :class="{
                'bg-primary-100 text-primary-800': !time?.priority,
                'bg-orange-100 text-orange-700': time?.priority
              }"
            >
              <BaseIconSvg
                v-if="time?.priority"
                name="flowbite:star-solid"
                class="mr-1 inline-block w-4! h-4!"
              />
              <BaseIconSvg
                v-else
                name="flowbite:calendar-month-outline"
                class="mr-1 inline-block w-4! h-4!"
              />
              <span
                class="text-sm font-medium flex items-center whitespace-nowrap"
                :class="{
                  'text-primary-800': !time?.priority,
                  'text-orange-700': time?.priority
                }"
              >
                {{time?._edit?.textLabel}}
              </span>
            </div>
          </div>
        </div>
      </template>
    </FwbTooltip>
  </div>
</template>
